import { asCurrency } from '@separate/utilities/string';

export const PREMIUM_ANNUAL_MEMBERSHIP_PRICE = 15000;
export const PREMIUM_MEMBERSHIP_PRICE = 1695;
export const PREMIUM_MEMBERSHIP_AS_CURRENCY = asCurrency(PREMIUM_MEMBERSHIP_PRICE / 100);
